{
  "blocks": [
    {
      "id": "program-iui-cycle",
      "kind": "program",
      "tags": ["iui", "both-partners", "treatment"],
      "title": "IUI Cycle",
      "subtitle": "Medicated or natural IUI with monitoring and TWW support",
      "icon": "💧",
      "body": {
        "duration": "1–2 months",
        "includes": [
          "Fertility baseline for her",
          "Ovulation monitoring with ultrasound",
          "Trigger shot timing (if medicated cycle)",
          "Sperm wash and intrauterine insemination",
          "Two-week wait support and beta-hCG testing"
        ],
        "priceRange": {
          "low": 800,
          "high": 2000
        },
        "currency": "USD",
        "status": "coming-soon",
        "forWhom": "both",
        "category": "treatment",
        "moduleIds": [
          "module-female-hormone-baseline",
          "module-iui-procedure",
          "module-tww-support"
        ],
        "phases": [
          {
            "title": "Assessment",
            "description": "Confirm ovarian function and timing",
            "moduleIds": ["module-female-hormone-baseline"]
          },
          {
            "title": "Insemination",
            "description": "Monitoring, trigger, and IUI procedure",
            "moduleIds": ["module-iui-procedure"]
          },
          {
            "title": "Two-Week Wait",
            "description": "Support through the waiting period",
            "moduleIds": ["module-tww-support"]
          }
        ],
        "steps": [
          {
            "title": "Baseline & monitoring",
            "description": "Confirm ovulation timing with ultrasound. Start medications if prescribed."
          },
          {
            "title": "IUI procedure",
            "description": "Sperm wash and insemination. Quick, in-office procedure."
          },
          {
            "title": "Wait & test",
            "description": "Two-week wait with support. Beta-hCG test at 14 days."
          }
        ]
      },
      "sources": [
        {
          "title": "Intrauterine insemination: evidence-based guidelines",
          "journal": "Human Reproduction Update",
          "year": 2021,
          "evidenceLevel": "meta-analysis"
        }
      ]
    }
  ],
  "relationships": [
    {
      "from": "program-iui-cycle",
      "to": "module-female-hormone-baseline",
      "type": "contains"
    },
    {
      "from": "program-iui-cycle",
      "to": "module-iui-procedure",
      "type": "contains"
    },
    {
      "from": "program-iui-cycle",
      "to": "module-tww-support",
      "type": "contains"
    }
  ],
  "localeVariants": []
}
